/* eslint-disable @typescript-eslint/no-explicit-any */
import NotifyMe from "@/components/partials/modal/notify-me";
import moment from "moment";

const UpcomingEvents = ({
  batches,
  origin,
}: {
  batches: any;
  origin?: string;
}) => {
  return (
    <div className="h-fit overflow-hidden rounded-2xl border border-blue-200 bg-slate-50">
      <div className="flex w-full flex-col justify-between gap-4 bg-blue-200 px-6 py-4 lg:flex-row lg:items-center">
        <h3 className="text-primary text-2xl font-semibold lg:text-3xl">
          Upcoming{" "}
          <span className="font-vollkorn font-normal italic">Sessions</span>
        </h3>
        <NotifyMe origin={origin} />
      </div>
      <ul className="[&>*:nth-child(even)]:bg-slate-50 [&>*:nth-child(odd)]:bg-white">
        {batches &&
          batches.map((batch: any) => (
            <li
              key={batch.id}
              className="text-primary border-b border-slate-100 px-6 py-3 text-lg font-medium lg:py-4 lg:text-xl"
            >
              {moment(batch.start_date).format("MMMM DD, YYYY")} -{" "}
              {moment(batch.end_date).format("MMMM DD, YYYY")}
            </li>
          ))}
        {!batches?.length && (
          <li className="text-primary border-b border-slate-100 px-6 py-3 text-center text-lg font-medium lg:py-4 lg:text-xl">
            No Upcoming Sessions
          </li>
        )}
      </ul>
    </div>
  );
};

export default UpcomingEvents;
